import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { CorrespondenceDocumentModel } from '../models/correspondence-document.model';
import { CorrespondenceDocumentBuild } from '../models/document-build.model';

@Injectable()
/**
 * CRUD actions related to an instance of correspondence
*/
export class CorrespondenceInstanceService extends BaseApiService {

    /**
     * Creates a new instance of correspondence from a template and model data
     * @param model
     */
    public createInstance(model: CorrespondenceDocumentBuild) {
        return this.post('Correspondence/Instance/GetDocumentDownloadId', model).pipe(
            catchError(this.handleError));
    }

    /**
     * Gets the Url to display the contents of a correspondence instance
     * @param correspondenceId
     */
    public getCorrespondenceContentUrl(correspondenceId: number): Observable<any> {
        return this.get('Correspondence/Instance/Content/' + correspondenceId);
    }

    /**
     * Returns the PDF to view before sending
     * @param model
     */
    public previewCorrespondence(model: CorrespondenceDocumentBuild) {
        return this.post('Correspondence/Instance/Preview', model, this.replacer, 'application/octet-stream').pipe(
            catchError(this.handleError));
    }

    /**
     * Sends the correspondence
     * @param model
     */
    public sendCorrespondence(model: CorrespondenceDocumentModel) {
        return this.post('Correspondence/Instance/SendCorrespondence', model);
        // .catch(this.handleError);
    }

    /**
     * Gets the Url to display the contents of a correspondence instance as a decoded string
     * @param correspondenceId
     */
    public getCorrespondenceContentUrlAsString(correspondenceId: number) {
        return this.serviceUrl + 'Correspondence/Instance/ContentAsString/' + correspondenceId;
    }

    /**
     * Gets the details about when the correspondence was sent and to whom
     * @param correspondenceId
     */
    public getCorrespondenceSentDetails(correspondenceId: number) {
        return this.get(`Correspondence/Instance/${correspondenceId}/SentDetails`);
    }

    /**
     * Gets correspondence detail
     * @param request
     */
    public getCorrespondenceDetail(correspondenceId: any) {
        return this.get('Correspondence/Instance/Details/' + correspondenceId);
    }

    /**
     * Gets correspondence history for type and value
     * @param identificationTypeId
     * @param identificationTypeValue
     */
    public getCorrespondenceHistory(identificationTypeId: number, identificationTypeValue: number) {
        return this.get(`Correspondence/Log/IdentificationType/${identificationTypeId}/IdentificationValue/${identificationTypeValue}`);
    }

    public getMRPCorrespondenceHistory(customerNumberId: number) {
        return this.get('Correspondence/Instance/MrpCorrespondence/' + customerNumberId);
    }

    /**
     * Returns additional attempts for sent correspondence
     * @param correspondenceId
     */
    public getAdditionalAttempts(correspondenceId: number) {
        return this.get(`Correspondence/Log/${correspondenceId}/AdditionalAttempts`);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
